export const DashboardYTDFinancialReportFormField = {
  date: 'date',
} as const;
